<template>
<div class="footer">
	<div class="box2">
		<div class="cf">
			<div class="fl footerTopLeft">
				<div class="tit f-24">{{siteInfo.title}}</div>
				<div class="telAndChat">
					<div class="hotLine">
						<div class="item">{{telArr1[0]}}：<a class="f-20" :href="'tel:'+telArr1[1]">{{telArr1[1]}}</a></div>
						<!-- &emsp;&emsp;商务合作：010-83296789 -->
						<div class="item">{{telArr2[0]}}：<a class="f-20" :href="'tel:'+telArr2[1]">{{telArr2[1]}}</a></div>
					</div>
					<div class="codeImg"><img src="@/assets/images/wechat-gzh.png"></div>
				</div>
			</div>
			<div class="ovh footerTopRight">
				<dl v-for="(item,index) in menusList" v-if="index>=1">
					<dt class="f-16" @click="showMenu(index)"><a :href="item.linkUrl">{{item.title}}</a></dt>
					<dd :style="{display:menu[index] ? 'block':''}" v-for="(item,ind) in menusList[index].subMenu"><a :href="item.linkUrl">{{item.title}}</a></dd>
				</dl>
			</div>
		</div>

		<div class="copyRight cf">
				<div class="font" v-html="siteInfo.copyright"></div>
				<div class="otherLink">
					<a target="_blank" class="item" :href="protocolUrl+'//'+hostnameUrl+'/privacy/'">隐私政策</a>
					<span>|</span>
					<a target="_blank" class="item" :href="protocolUrl+'//'+hostnameUrl+'/copyright/'">版权声明</a>
					<span>|</span>
					<a target="_blank" class="item" :href="protocolUrl+'//'+hostnameUrl+'/user-services/'">用户服务协议</a>
				</div>
		</div>
	</div>
</div>  

<!-- <div v-html="footHtml"></div> -->
</template>
<script>
import { getFooter,getBaseInfo } from "@/api/person/person";
export default {
	name: 'foots',
	data(){
		return{
			footHtml:'',
			menu:[false,false,false,false,false],
			menusList:[], 
			siteInfo:[],
			hostnameUrl:window.location.hostname,
			protocolUrl:window.location.protocol,
			telArr1:[],
			telArr2:[]
		}
	},
	mounted(){
		let that=this
		//that.getFooterFun()
		that.getFootInfoFun()
	},
	activated(){
		
	},
	computed:{
		
	},
	methods: {
		getFooterFun(){
	      let that=this
	      getFooter({}).then(res => {
	        //console.log(res)
	        that.footHtml=res
	      });
	    },
	    getFootInfoFun(){
	      let that=this
	      getBaseInfo({}).then(res => {
	        //console.log(res)
	        if(res.success) {
	        	//that.menusList=res.result.menus  
	        	let menusList=res.result.menus
	        	let baseUrl=that.protocolUrl+'//'+that.hostnameUrl
	        	menusList.forEach((item,index)=>{
	        		if (item.linkUrl.includes("https://www.zgjzcy.org.cn")) {
	        			item.linkUrl=item.linkUrl.replace("https://www.zgjzcy.org.cn", baseUrl)
	        		}
	        	})

	        	that.menusList=menusList
	        	that.siteInfo=res.result.siteInfo
				let tel=that.siteInfo.contact
				that.telArr1=tel.split("\n")[0].split("：")
				that.telArr2=tel.split("\n")[1].split("：")
	        }
	      });
	    },
	    showMenu(ind){
	    	let that=this
	    	let menuShow=[]
	    	that.menu.forEach((item,index)=>{
	    		if (index==ind) {
	    			item=!item
	    		}else{
	    			item=false
	    		}
	    		menuShow.push(item)
	    	})
	    	that.menu=menuShow
	    }
   	}
}
</script>


// WEBPACK FOOTER //
// src/components/global/foots/index.vue